import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';
import { Provincias } from 'types/Provincias';

export async function getProvincias(paisId: number | undefined): Promise<Provincias[]> {
  try {
    const url = new URL(`${ config.baseUrl }/provincias`);

    if (paisId !== undefined) {
      url.searchParams.append('pais_id', paisId.toString());
    }

    type Response = APIResponse<Provincias[]>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      throw new Error('Ocurrió un problema de conexión al momento de intentar recuperar las provincias.');
    }

    const content = await response.json() as Response;
    if (content.status !== 'ok' || !content.payload) {
      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las provincias.');
    }

    return content.payload;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
